import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <p class="mb-3">
      La odoro de gaso. 
      Ĝi elfluas el la pordo kaj disvastiĝas laŭ la ŝtuparo de multetaĝa domo. 
      Lante, poiomete ĝi atingas suprajn etaĝojn, kaj jam la tuta domo estas saturita de tiu apenaŭ sentebla kaj apenaŭ priskribebla, sed tute unusignifa odoro. 
      Odoro de danĝero.
    </p>
    
    <p class="mb-3">
      Jen iu enŝaltis la lumon en sia ĉambro; ne, plej verŝajne en necesejo, kien oni venadas kelkfoje dumtage. 
      Klik’…  
      Kaj la eksplodo skuis la domon. 
      Elsaltis fenestroj kun la framoj, el fenestroj elflugis etaj aĵoj; poste la flamo el iuj funkciintaj gasfornoj inundis la tutan internaĵon de la domo.
    </p>

    <p class="mb-3">
      Aŭdiĝis krioj de homoj, kiuj restis hejme dum tiu tagmezo.
    </p>
    
    <p class="mb-3">
      Poste evidentiĝis, ke pereis 7 personoj, kaj 20 loĝejoj estis detruitaj.
    </p>
    
    <p class="mb-3">
      La gaso elfluis el la loĝejo № 8, kie junulo metis bolkruĉon kun akvo por kafo, kaj forgesis reveni al la kuirejo, allogita de novaj mesaĝoj en sia komputilo. 
      Estis tiel interesa konversacio, ke li forgesis pri ĉio; kaj kiam la gaso atingis lian ĉambron, li ne rimarkis ankaŭ la odoron. 
      Kaj tiel nerimarkeble la gaso svenigis lin ĉe l’ komputilo, kaj poste lante trapenetris la domon. 
    </p>

    <p class="mb-3">
      Pereis 7 personoj, kaj 20 loĝejoj estis detruitaj.
    </p>
    `
  )
}

const itemName = {
  esp: 'Odoro de gaso'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}

export default item;